/**
 * Queries the suggest.json endpoint to get search results.
 * @param {String} query query used when searching
 * @param {Object} resources object that builds the resources query string see https://shopify.dev/api/ajax/reference/predictive-search for more information on resources object
 */

export async function getResults(variables) {
  try {
    let route = window.cnvs.routes.root

    if (route !== '/') {
      route = `${route}/`
    }

    let results = await fetch(`${route}search?q=${variables.query}&view=json&type=product&sort_key=relevance`)
      .then(response => response.json())
      .then((data) => {
        return data.products
      })

    if (variables.isVip) {
      return results
    }

    results = results.filter((result) => {
      return !result.vipProduct
    })

    return results
  } catch (error) {
    reportError('Error with getting search results', error)
  }
}
